import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 1.875C14.4876 1.875 18.125 5.51239 18.125 10C18.125 14.4867 14.4876 18.125 10 18.125C5.51234 18.125 1.875 14.4867 1.875 10C1.875 5.51239 5.51239 1.875 10 1.875ZM10.0049 8.87012C9.6597 8.87012 9.37988 9.14994 9.37988 9.49512V13.0781C9.38013 13.4231 9.65986 13.7031 10.0049 13.7031C10.3498 13.7031 10.6296 13.423 10.6299 13.0781V9.49512C10.6299 9.14998 10.35 8.87019 10.0049 8.87012ZM10 6.28418C9.65482 6.28418 9.375 6.564 9.375 6.90918V6.96191C9.37502 7.30708 9.65483 7.58691 10 7.58691C10.3452 7.58691 10.625 7.30708 10.625 6.96191V6.90918C10.625 6.564 10.3452 6.28418 10 6.28418Z",
		fill: "currentColor"
	})
});
export default SvgInfoCircleFill;
